const Quiz = () => ({
  data: {},
  step: 1,
  pets_type: '',
  pets_quantity: 0,
  general_attributes: [],
  pets: [],

  get progressBarWidth() {
    return `width: calc(100% / ${this.data.quiz_size} * ${this.step});`;
  },

  get multiplePets() {
    return this.pets.length > 1;
  },

  getInitialData() {
    const dataElement = document.querySelector('#data-structure');
    if(!dataElement) return;
    const structuredData = JSON.parse(dataElement.innerHTML);
    this.data = structuredData;
    this.pets = [];
    localStorage.setItem('flea-tag-quiz-data', '');
  },

  setPetsQuantity(quantity) {
    if(this.$el.classList.contains('active')) return;
    const quantityButtons = document.querySelectorAll('[data-pets-quantity]');
    quantityButtons.forEach(button => button.classList.remove('active'));
    this.pets = [];
    this.pets_quantity = Number(quantity);
    this.$el.classList.add('active');
    
    setTimeout(()=> {
      this.step += 1;
    }, 200)
  },

  setGeneralInfo(answer, attribute) {
    const generalInfoButtons = document.querySelectorAll(`[data-${attribute}]`);
    generalInfoButtons.forEach(button => button.classList.remove('active'));
    
    const attributeObject = {
      [attribute]: answer
    };

    const index = this.general_attributes.findIndex(obj => obj.hasOwnProperty(attribute));
    index !== -1 ? this.general_attributes[index] = attributeObject : this.general_attributes.push(attributeObject);
    this.$el.classList.add('active');
    setTimeout(()=> {
      this.step += 1;
      this.showResults();
    }, 200)
  },

  setPrimaryValues(index, attribute) {
    this.pets[index][attribute] = this.$el.value;
    this.undisableConfirm(attribute);
  },

  showResults() {
    if (this.step <= this.data.quiz_size) return;
    const pets = this.pets.map(pet => `${pet.pet_name}--${pet.pet_weight}`);
    const searchParams = new URLSearchParams();
    searchParams.set('pets', pets)
    this.prepareDataForRequest();
    const url = `${this.data.product_url}?view=quiz-product&${searchParams}`;    
    this.$root.style.display = 'none';
    window.location.href = url;
  },

  confirm() {
    setTimeout(()=> {
      this.showResults();
      this.step += 1;
    }, 200)
  },

  goBack() {
    setTimeout(() => {
      this.step -= 1; 
    }, 200)
  },

  undisableConfirm(attribute) {
    const confirmButton = this.$el.closest('.answers-container').querySelector('.confirm');
    if (attribute !== 'pet_name' && attribute !== 'pet_weight') return;
    const nameAttributes = this.pets.map(pet => pet.pet_name);
    const weightAttribites = this.pets.map(pet => pet.pet_weight);
    const emptyValue = [...nameAttributes, ...weightAttribites].some(value => value === '');
    !emptyValue ? confirmButton.disabled = false : confirmButton.disabled = true;
  },

  preparePetsData() {
    const petData = this.data.pet;
    this.pets = Array.from({ length: this.pets_quantity }, () => JSON.parse(JSON.stringify(petData)));
  },

  prepareDataForRequest() {
    const request = this.general_attributes.reduce((acc, obj) => {
      return { ...acc, ...obj };
    }, {});

    request.pets = this.pets;
    localStorage.setItem('flea-tag-quiz-data', JSON.stringify(request));
  },

  scrollToTop() {
    if(window.scrollY === 0) return;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  },

  init() {
    this.getInitialData();
    this.$watch('step', ()=> this.scrollToTop());
    this.$watch('pets_quantity', ()=> this.preparePetsData());
  }
})

document.addEventListener('alpine:init', ()=> {  
  Alpine.data('quiz', Quiz);
})